import { ChevronRight } from "lucide-react";

import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const REQUEST_ACCESS_URL = "https://cargominds.ai/contact-us/";

export const RequestAccessButton = ({ className }) => (
    <a
        href={REQUEST_ACCESS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(
            "inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-[6px] bg-cm-p-accent-500 py-2 pl-4 pr-3.5",
            "text-sm font-medium text-cm-p-neutral-dark-500 transition-colors hover:bg-cm-p-primary-hovered active:bg-cm-p-primary-pressed",
            className,
        )}
    >
        <TranslatedText>Request access</TranslatedText>
        <ChevronRight className="size-4" strokeWidth={2} />
    </a>
);
